/*!
 * Bundle Builder — Matchmaker UX polish, 22 Sep 2026
 * Copyright © 2026 Dolphin & Dog Pty Ltd. All rights reserved.
 *
 * This custom code may not be copied, reproduced, modified, distributed,
 * sold, or used commercially without prior written permission from
 * Dolphin & Dog Pty Ltd, except as permitted by law.
 */
(function(){
  document.querySelectorAll('[data-bbb-root]').forEach(function(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';

    var dataEl=root.querySelector('[data-bbb-data]');
    var data;

    try{
      data=JSON.parse(dataEl.textContent);
    }catch(error){
      console.error('Bundle builder JSON error',error);
      return;
    }

    var settings=data.settings||{};
    var copy=settings.copy||{};
    var steps=data.steps||['Build Your Bundle','Review Bundle'];

    var tiers=(data.discountTiers||[])
      .filter(function(tier){
        return +tier.threshold>0&&+tier.percent>0;
      })
      .sort(function(a,b){
        return a.threshold-b.threshold;
      });

    var money=new Intl.NumberFormat('en-AU',{
      style:'currency',
      currency:settings.currency||'AUD'
    });

    var catalog={
      products:(data.products||[]).map(normaliseProduct).filter(Boolean)
    };

    var nodes={
  steps:root.querySelector('[data-bbb-steps]'),
  screen:root.querySelector('[data-bbb-screen]'),
  count:root.querySelector('[data-bbb-count]'),
  discount:root.querySelector('[data-bbb-discount]'),
  trayItems:root.querySelector('[data-bbb-tray-items]'),
  total:root.querySelector('[data-bbb-total]'),
  modal:root.querySelector('[data-bbb-modal]'),
  loading:root.querySelector('[data-bbb-loading]'),
  loadingLabel:root.querySelector('[data-bbb-loading-label]'),
  loadingVisual:root.querySelector('[data-bbb-loading-visual]'),
  toast:root.querySelector('[data-bbb-toast]')
};

setupFooterTrayVisibility();

function setupFooterTrayVisibility(){
  var tray=root.querySelector('.bbb__tray');

  var footer=document.querySelector(
    '.shopify-section-group-footer-group, '+
    '#shopify-section-footer, '+
    'footer'
  );

  if(
    !tray||
    !footer||
    !('IntersectionObserver' in window)
  ){
    return;
  }

  var footerObserver=new IntersectionObserver(
    function(entries){
      tray.classList.toggle(
        'bbb__tray--footer-hidden',
        entries[0].isIntersecting
      );
    },
    {
      threshold:0
    }
  );

  footerObserver.observe(footer);
}

var state={
  step:0,
  review:false,
  filter:'All',
  sort:'featured',
  lines:[],
  submittedBundleId:'',
  submittedInCart:false,
  modal:{
    product:null,
    qty:1,
    options:[],
    img:0
  }
};

    var matchmakerContext=readMatchmakerHandoff();
    var matchmakerStorageSuffix=matchmakerContext
      ? ':matchmaker:'+(matchmakerContext.journeyKey||'active')
      : '';
    var storageKey='ddBundleBuilder:'+location.pathname+':'+(root.id||'default')+matchmakerStorageSuffix;
    var storageMaxAge=24*60*60*1000;
    var loadingDelayTimer=null;
    var cartSubmitting=false;
    var cartEditing=false;
    var historyStateKey='bbb-'+Date.now()+'-'+Math.random().toString(36).slice(2);
var ignoreNextPopstate=false;
var existingBuilderEligible=0;
var matchmakerAutoAdvanceTimer=null;

/*
  Matchmaker handoff.
  The Matchmaker sends a short URL marker plus a richer sessionStorage
  payload. Keeping the Builder state in a journey-specific storage key
  prevents an older normal Builder session from contaminating a fresh
  Matchmaker recommendation.
*/
function readMatchmakerHandoff(){
  var source='';
  var queryKit=[];

  try{
    var params=new URLSearchParams(window.location.search||'');
    source=String(params.get('source')||'');
    queryKit=String(params.get('kit')||'')
      .split(',')
      .map(function(value){ return value.trim(); })
      .filter(Boolean);
  }catch(error){}

  if(source!=='dog-towel-matchmaker'){
    return null;
  }

  var payload=null;

  try{
    var raw=window.sessionStorage&&
      window.sessionStorage.getItem('ddMatchmakerResult');

    if(raw){
      payload=JSON.parse(raw);
    }
  }catch(error){
    payload=null;
  }

  if(
    payload&&
    payload.createdAt&&
    Date.now()-Number(payload.createdAt)>2*60*60*1000
  ){
    payload=null;
  }

  var handles=payload&&Array.isArray(payload.handles)
    ? payload.handles.map(String).filter(Boolean)
    : queryKit;
  var recommendations=payload&&Array.isArray(payload.recommendations)
    ? payload.recommendations.map(String)
    : [];
  var quantities=payload&&payload.quantities&&typeof payload.quantities==='object'
    ? payload.quantities
    : {};

  if(!handles.length){
    return null;
  }

  var entries=handles.map(function(handle,index){
    var key=recommendations[index]||handle;
    var quantity=Math.max(1,+quantities[key]||1);

    return {
      key:key,
      handle:handle,
      quantity:quantity,
      index:index
    };
  });

  var sessionId=payload
    ? String(payload.matchmaker_session_id||payload.sessionId||'')
    : '';
  var createdAt=payload&&payload.createdAt
    ? Number(payload.createdAt)
    : Date.now();
  var breedName=payload&&payload.breedProfile&&payload.breedProfile.name
    ? String(payload.breedProfile.name)
    : '';
  var journeyKey=(sessionId||String(createdAt))
    .replace(/[^a-zA-Z0-9_-]/g,'')
    .slice(0,80)||'active';

  return {
    source:'dog-towel-matchmaker',
    journeyKey:journeyKey,
    sessionId:sessionId,
    breedName:breedName,
    recommendations:recommendations,
    entries:entries,
    createdAt:createdAt,
    multiWearable:entries.some(function(entry){
      return /(^|_)robe($|_)/.test(entry.key)&&entry.quantity>1;
    })
  };
}

function findProductByHandle(handle){
  handle=String(handle||'').toLowerCase();

  return catalog.products.find(function(product){
    return String(product.handle||'').toLowerCase()===handle;
  })||null;
}

function matchmakerEntryForProduct(product){
  if(!matchmakerContext||!product){
    return null;
  }

  return matchmakerContext.entries.find(function(entry){
    return String(entry.handle||'').toLowerCase()===
      String(product.handle||'').toLowerCase();
  })||null;
}

function matchmakerEntryByKey(key){
  if(!matchmakerContext){
    return null;
  }

  return matchmakerContext.entries.find(function(entry){
    return entry.key===key;
  })||null;
}

function isWearableRecommendation(entry){
  if(!entry){
    return false;
  }

  return /(^|_)robe($|_)/.test(String(entry.key||''));
}


function matchmakerOrdinal(number){
  number=Math.max(1,parseInt(number,10)||1);

  var mod100=number%100;

  if(mod100>=11&&mod100<=13){
    return number+'th';
  }

  switch(number%10){
    case 1:return number+'st';
    case 2:return number+'nd';
    case 3:return number+'rd';
    default:return number+'th';
  }
}

function matchmakerChoiceType(entry){
  var key=String(entry&&entry.key||'').toLowerCase();

  if(isWearableRecommendation(entry)){
    return 'size';
  }

  if(
    key==='bath_towel'||
    key==='beach_towel'
  ){
    return 'colour';
  }

  return 'options';
}

function matchmakerActionLabel(entry,done,quantity,complete){
  var choiceType=matchmakerChoiceType(entry);
  var nextNumber=Math.min(
    Math.max(1,+quantity||1),
    Math.max(0,+done||0)+1
  );

  if(complete){
    if(choiceType==='colour'){
      return quantity>1
        ? '✓ '+quantity+' colours chosen'
        : '✓ Colour chosen';
    }

    if(choiceType==='size'){
      return quantity>1
        ? '✓ '+quantity+' sizes chosen'
        : '✓ Size chosen';
    }

    return '✓ Recommended quantity added';
  }

  if(choiceType==='colour'){
    return quantity>1
      ? 'Choose '+matchmakerOrdinal(nextNumber)+' colour'
      : 'Choose colour';
  }

  if(choiceType==='size'){
    return quantity>1
      ? 'Choose '+matchmakerOrdinal(nextNumber)+' size'
      : 'Choose size';
  }

  return quantity>1
    ? 'Configure '+matchmakerOrdinal(nextNumber)+' item'
    : 'Choose options';
}

function matchmakerItemNoun(entry,singular){
  var choiceType=matchmakerChoiceType(entry);

  if(choiceType==='colour'){
    return singular?'towel':'towels';
  }

  if(choiceType==='size'){
    return singular?'robe':'robes';
  }

  return singular?'item':'items';
}

function matchmakerSequenceButtonLabel(entry,done,target){
  var choiceType=matchmakerChoiceType(entry);
  var current=Math.min(target,Math.max(0,done)+1);

  if(current<target){
    if(choiceType==='colour'){
      return 'Save '+matchmakerOrdinal(current)+' colour & choose '+matchmakerOrdinal(current+1)+' →';
    }

    if(choiceType==='size'){
      return 'Save '+matchmakerOrdinal(current)+' size & choose '+matchmakerOrdinal(current+1)+' →';
    }

    return 'Save '+matchmakerOrdinal(current)+' item & continue →';
  }

  return 'Add '+matchmakerOrdinal(current)+' '+matchmakerItemNoun(entry,true)+' & finish →';
}

function configuredMatchmakerSelections(entry){
  if(!entry){
    return [];
  }

  var product=findProductByHandle(entry.handle);

  if(!product){
    return [];
  }

  var target=Math.max(1,+entry.quantity||1);
  var selections=[];

  state.lines.forEach(function(line){
    if(+line.productId!==+product.id){
      return;
    }

    var label=line.variantTitle||
      line.title||
      product.title||
      'Selected';

    for(
      var index=0;
      index<Math.max(1,+line.qty||1)&&selections.length<target;
      index+=1
    ){
      selections.push(label);
    }
  });

  return selections;
}

function configuredMatchmakerQuantity(entry){
  if(!entry){
    return 0;
  }

  var product=findProductByHandle(entry.handle);

  if(!product){
    return 0;
  }

  return state.lines.reduce(function(total,line){
    return total+(+line.productId===+product.id
      ? Math.max(1,+line.qty||1)
      : 0);
  },0);
}

function remainingMatchmakerQuantity(entry){
  return Math.max(
    0,
    Math.max(1,+entry.quantity||1)-configuredMatchmakerQuantity(entry)
  );
}

function matchmakerTargetCount(){
  if(!matchmakerContext){
    return 0;
  }

  return matchmakerContext.entries.reduce(function(total,entry){
    return total+Math.max(1,+entry.quantity||1);
  },0);
}

function matchmakerConfiguredCount(){
  if(!matchmakerContext){
    return 0;
  }

  return matchmakerContext.entries.reduce(function(total,entry){
    return total+Math.min(
      Math.max(1,+entry.quantity||1),
      configuredMatchmakerQuantity(entry)
    );
  },0);
}

function matchmakerRecommendationsReady(){
  return !!matchmakerContext&&
    matchmakerContext.entries.every(function(entry){
      return remainingMatchmakerQuantity(entry)===0;
    });
}

function matchmakerAnalyticsFields(){
  if(!matchmakerContext){
    return {
      journey_source:'bundle_builder',
      matchmaker_session_id:'',
      matchmaker_breed:'',
      matchmaker_recommendations:'',
      recommended_target_count:0,
      recommended_configured_count:0
    };
  }

  return {
    journey_source:'dog_towel_matchmaker',
    matchmaker_session_id:matchmakerContext.sessionId||'',
    matchmaker_breed:matchmakerContext.breedName||'',
    matchmaker_recommendations:matchmakerContext.entries
      .map(function(entry){ return entry.key; })
      .join(','),
    recommended_target_count:matchmakerTargetCount(),
    recommended_configured_count:matchmakerConfiguredCount()
  };
}

function matchmakerRecommendationAnalytics(product,recommendationKey){
  var entry=recommendationKey
    ? matchmakerEntryByKey(recommendationKey)
    : matchmakerEntryForProduct(product);

  if(!entry){
    return {
      recommended_item:'no',
      recommendation_key:'',
      recommendation_target_quantity:0
    };
  }

  return {
    recommended_item:'yes',
    recommendation_key:entry.key,
    recommendation_target_quantity:Math.max(1,+entry.quantity||1)
  };
}

function openMatchmakerRecommendation(entry){
  if(!entry){
    return;
  }

  var product=findProductByHandle(entry.handle);

  if(!product){
    showToast('One recommended product is not available in the Bundle Builder right now.');
    return;
  }

  if(hasOptions(product)){
    openModal(product,entry);
    return;
  }

  addSimple(product,entry);
}

function afterMatchmakerRecommendationAdded(entry){
  if(!matchmakerContext){
    return;
  }

  renderProducts();
  renderTray();
  updateTrayButton();
  saveState();

  window.clearTimeout(matchmakerAutoAdvanceTimer);

  var product=entry
    ? findProductByHandle(entry.handle)
    : null;
  var productTitle=product
    ? product.title
    : 'Recommended item';
  var target=entry
    ? Math.max(1,+entry.quantity||1)
    : 1;
  var done=entry
    ? Math.min(target,configuredMatchmakerQuantity(entry))
    : 1;
  var remaining=Math.max(0,target-done);

  /*
    Stay on the Bundle Builder after every selection.
    The customer chooses when to configure/add the next item instead
    of being pushed straight into another very similar modal.
  */
  if(matchmakerRecommendationsReady()){
    showToast(productTitle+' saved. Your Matchmaker picks are ready to review.');
    return;
  }

  if(remaining>0){
    showToast(
      productTitle+' saved — '+done+' of '+target+
      ' chosen. Choose “'+
      matchmakerActionLabel(entry,done,target,false)+
      '” when you’re ready.'
    );
    return;
  }

  showToast(productTitle+' saved. Choose the next Matchmaker pick when you’re ready.');
}

function matchmakerRecommendationPanel(){
  if(!matchmakerContext){
    return '';
  }

  var configured=matchmakerConfiguredCount();
  var target=matchmakerTargetCount();
  var ready=target>0&&configured>=target;
  var breedCopy=matchmakerContext.breedName
    ? ' for '+escapeHtml(matchmakerContext.breedName)
    : '';
  var cards=matchmakerContext.entries.map(function(entry){
    var product=findProductByHandle(entry.handle);

    if(!product){
      return '<article class="bbb__matchmaker-card is-missing">'+
        '<span class="bbb__matchmaker-badge">MATCHMAKER PICK</span>'+
        '<h3>'+escapeHtml(entry.key)+'</h3>'+
        '<p>This recommended product is not currently available in the Builder.</p>'+
      '</article>';
    }

    var variant=firstVariant(product);
    var image=product.featuredImage||(variant&&variant.image)||'';
    var done=configuredMatchmakerQuantity(entry);
    var quantity=Math.max(1,+entry.quantity||1);
    var remaining=Math.max(0,quantity-done);
    var complete=remaining===0;
    var actionLabel=complete
      ? matchmakerActionLabel(entry,done,quantity,true)
      : (hasOptions(product)
          ? matchmakerActionLabel(entry,done,quantity,false)
          : 'Add recommended item');
    var status=quantity>1
      ? Math.min(done,quantity)+' of '+quantity+' chosen'
      : (complete?'Ready':'Recommended');

    return '<article class="bbb__matchmaker-card '+(complete?'is-ready':'')+'">'+
      '<span class="bbb__matchmaker-badge">MATCHMAKER PICK</span>'+
      '<div class="bbb__matchmaker-card-media">'+
        (image
          ? '<img src="'+escapeAttr(image)+'" alt="'+escapeAttr(product.title)+'" loading="lazy">'
          : '<div class="bbb__fallback">'+escapeHtml(product.title)+'</div>')+
      '</div>'+
      '<div class="bbb__matchmaker-card-copy">'+
        '<h3>'+escapeHtml(product.title)+'</h3>'+
        '<p>Recommended ×'+quantity+' · '+escapeHtml(status)+'</p>'+
      '</div>'+
      '<button type="button" class="bbb__soft bbb__matchmaker-action" '+
        'data-bbb-matchmaker-action data-bbb-product="'+product.id+'" '+
        'data-bbb-recommendation-key="'+escapeAttr(entry.key)+'" '+
        (complete?'disabled aria-disabled="true"':'')+'>'+escapeHtml(actionLabel)+'</button>'+
    '</article>';
  }).join('');

  return '<section class="bbb__matchmaker-panel">'+
    '<div class="bbb__matchmaker-head">'+
      '<div><span class="bbb__matchmaker-kicker">DOG TOWEL MATCHMAKER</span>'+
      '<h2>Your Matchmaker picks are ready'+breedCopy+'.</h2>'+
      '<p>Choose the colours and sizes for each recommended item. Once they’re all ready, review your bundle — or add optional extras below.</p></div>'+
      '<div class="bbb__matchmaker-progress '+(ready?'is-ready':'')+'">'+
        '<strong>'+configured+' / '+target+'</strong><span>'+(ready?'Ready to review':'chosen')+'</span>'+
      '</div>'+
    '</div>'+
    '<div class="bbb__matchmaker-grid">'+cards+'</div>'+
    '<div class="bbb__matchmaker-extras"><strong>Want to add anything else?</strong><span>Optional extras are available in the full Builder below.</span></div>'+
  '</section>';
}

/*
  Builder analytics state.
*/
var builderViewTracked=false;
var lastTrackedDiscountPercent=null;

function builderItemCount(){
  return state.lines.reduce(function(total,line){
    return total+Math.max(1,+line.qty||1);
  },0);
}

function analyticsMoney(cents){
  return Number(
    ((Number(cents)||0)/100).toFixed(2)
  );
}

function currentBuilderStepName(){
  if(state.review){
    return 'review';
  }

  return 'products';
}

/*
  GA4 transport only.
  The Builder payload below remains the canonical Dolphin & Dog event for
  dataLayer, Shopify analytics and a future ManyB adapter. This helper does
  not load Google's script; it uses the Google tag already installed by the
  Shopify Google & YouTube app.
*/
function sendBuilderEventToGA4(eventName,payload){
  try{
    if(typeof window.gtag!=='function'){
      console.debug(
        'Builder GA4 transport unavailable: Google tag not ready.'
      );

      return false;
    }

    var pagePath=String(
      payload&&payload.page_path
        ? payload.page_path
        : window.location.pathname
    );

    var parameters={
      send_to:'G-SCDK7SNV08',
      builder_type:payload.builder_type,
      builder_step:payload.builder_step,
      item_group:payload.item_group,
      page_path:pagePath,
      page_location:'https://www.dolphinanddog.com.au'+pagePath,
      currency:payload.currency,
      item_count:payload.item_count,
      current_builder_value:payload.current_builder_value,
      current_eligible_value:payload.current_eligible_value,
      existing_builder_value:payload.existing_builder_value,
      combined_builder_value:payload.combined_builder_value,
      discount_percent:payload.discount_percent,
      is_review:payload.is_review,
      is_submitted:payload.is_submitted,
      entry_step:payload.entry_step,
      product_id:payload.product_id,
      variant_id:payload.variant_id,
      product_title:payload.product_title,
      quantity_added:payload.quantity_added,
      quantity_removed:payload.quantity_removed,
      line_quantity:payload.line_quantity,
      unit_price:payload.unit_price,
      previous_discount_percent:payload.previous_discount_percent,
      new_discount_percent:payload.new_discount_percent,
      review_item_count:payload.review_item_count,
      submitted_item_count:payload.submitted_item_count,
      submitted_value:payload.submitted_value,
      submitted_discount_percent:payload.submitted_discount_percent,
      submitted_discount_value:payload.submitted_discount_value,
      destination:payload.destination,
      bundle_id:payload.bundle_id,
      gift_box_id:payload.gift_box_id,
      card_selected:payload.card_selected,
      message_used:payload.message_used
    };

    if(
      eventName==='builder_add_to_cart'&&
      payload.submitted_value!=null
    ){
      parameters.value=Number(payload.submitted_value)||0;
    }

    Object.keys(parameters).forEach(function(key){
      if(
        parameters[key]===undefined||
        parameters[key]===null||
        parameters[key]===''
      ){
        delete parameters[key];
      }
    });

    window.gtag(
      'event',
      eventName,
      parameters
    );

    return true;
  }catch(error){
    console.debug(
      'Builder GA4 transport unavailable:',
      error
    );

    return false;
  }
}

function trackBuilderEvent(eventName,details){
  var price=pricing();

  var payload=Object.assign({
    analytics_event:eventName,
    builder_type:'bundle',
    page_path:window.location.pathname,
    currency:settings.currency||'AUD',
    builder_step:currentBuilderStepName(),
    item_count:builderItemCount(),
    current_builder_value:analyticsMoney(price.subtotal),
    existing_builder_value:analyticsMoney(existingBuilderEligible),
    combined_builder_value:analyticsMoney(price.combinedEligible),
    discount_percent:+price.percent||0,
    is_review:!!state.review,
    is_submitted:!!state.submittedInCart
  },matchmakerAnalyticsFields(),details||{});

  window.dataLayer=window.dataLayer||[];

  window.dataLayer.push(
    Object.assign({
      event:'dolphin_dog_builder_event'
    },payload)
  );

  sendBuilderEventToGA4(
    eventName,
    payload
  );

  var publishPromise=Promise.resolve(false);

  try{
    if(
      window.Shopify&&
      Shopify.analytics&&
      typeof Shopify.analytics.publish==='function'
    ){
      publishPromise=Promise.resolve(
        Shopify.analytics.publish(
          'dolphin_dog:builder_event',
          payload
        )
      )
      .catch(function(error){
        console.debug(
          'Builder analytics publish skipped:',
          error
        );

        return false;
      });
    }
  }catch(error){
    console.debug(
      'Builder analytics unavailable:',
      error
    );
  }

  console.debug(
    '[Dolphin & Dog Builder Analytics]',
    payload
  );

  return publishPromise;
}

function trackBuilderView(){
  if(builderViewTracked){
    return;
  }

  builderViewTracked=true;

  trackBuilderEvent('builder_view',{
    entry_step:state.review
      ? 'review'
      : 'products',
    entry_source:matchmakerContext
      ? 'dog_towel_matchmaker'
      : 'bundle_builder'
  });
}

function trackDiscountTier(price){
  var currentPercent=
    price&&price.percent
      ? +price.percent
      : 0;

  if(lastTrackedDiscountPercent===null){
    lastTrackedDiscountPercent=currentPercent;
    return;
  }

  if(currentPercent===lastTrackedDiscountPercent){
    return;
  }

  trackBuilderEvent('builder_tier_change',{
    previous_discount_percent:
      lastTrackedDiscountPercent,
    new_discount_percent:
      currentPercent
  });

  lastTrackedDiscountPercent=currentPercent;
}

    loadSavedState();
render();
replaceBuilderHistory(false);

refreshExistingBuilderValue().then(function(){
  render();
  trackBuilderView();
  trackDiscountTier(pricing());
});

    root.addEventListener('click',handleClick);
    root.addEventListener('change',handleChange);

    window.addEventListener('pageshow',function(){
  window.clearTimeout(loadingDelayTimer);
  loadingDelayTimer=null;
  cartSubmitting=false;
  cartEditing=false;
  loading(false);

  refreshExistingBuilderValue().then(function(){
    verifySubmittedBundle();
  });
});

    window.addEventListener('popstate',function(event){
      if(ignoreNextPopstate){
        ignoreNextPopstate=false;
        return;
      }

      var historyState=event.state||{};

      /*
        Mobile back/gesture should close the open product modal first,
        even if the browser has dropped custom state from the destination
        history entry. A second Back can then leave the Builder normally.
      */
      if(nodes.modal&&nodes.modal.classList.contains('is-open')){
        closeModal(true);

        if(historyState.bbbKey!==historyStateKey){
          replaceBuilderHistory(false);
        }

        return;
      }

      if(historyState.bbbKey!==historyStateKey){
        return;
      }

      state.step=Math.max(0,Math.min(1,+historyState.bbbStep||0));
      state.review=!!historyState.bbbReview;
      resetFilter();
      render();
      scrollToBuilder();
    });

    function render(){
  renderSteps();

  var staticHero=
    root.querySelector('[data-bbb-static-hero]');

  if(staticHero){
    staticHero.hidden=state.review;
  }

  if(state.review){
    renderReview();
  }else{
    renderProducts();
  }

  renderTray();
  updateTrayButton();
  saveState();
}

    function renderSteps(){
      var progress=state.review?100:0;

      nodes.steps.style.setProperty('--bbb-step-progress',progress+'%');

      nodes.steps.innerHTML=steps.map(function(label,index){
        var complete=state.review&&index===0;
        var active=state.review?index===1:index===0;
        var icon=complete?'✓':(index===0?'▧':'✓');

        return ''+
          '<button type="button" class="bbb__step '+
            (complete?'is-complete ':'')+
            (active?'is-active':'')+
          '" data-bbb-step="'+index+'">'+
            '<span class="bbb__step-icon">'+icon+'</span>'+
            '<span class="bbb__step-title">'+escapeHtml(label)+'</span>'+
          '</button>';
      }).join('');
    }

    function renderProducts(){
  var products=prepareProducts(catalog.products);

  nodes.screen.innerHTML=
    (matchmakerContext?matchmakerRecommendationPanel():'')+
    productToolbar()+
    '<div class="bbb__grid">'+
      (
        products.length
          ? products.map(productCard).join('')
          : emptyProducts()
      )+
    '</div>';
}

    function renderReview(){
      var lines=cartLines();
      var price=pricing();
      var itemCount=lines.reduce(function(total,line){
        return total+(+line.qty||1);
      },0);
      var itemLabel=itemCount===1?'Item':'Items';
      var cartButtonLabel=state.submittedInCart
        ? 'Return to Cart'
        : (copy.addToCart||'Add Bundle To Cart');
      var reviewHeaderActions=state.submittedInCart
        ? ''
        : '<div><button class="bbb__link" data-bbb-edit type="button">'+escapeHtml(copy.edit||'Edit')+'</button> <button class="bbb__link bbb__danger" data-bbb-reset type="button">'+escapeHtml(copy.remove||'Remove')+'</button></div>';
      var inCartNotice=state.submittedInCart
        ? '<div class="bbb__empty" data-bbb-notice>This bundle is already in your cart. To change it, choose Edit This Bundle. It will be temporarily removed from the cart while you make changes.</div>'
        : '<div class="bbb__empty" data-bbb-notice hidden></div>';
      var leadLine=lines[0]||null;

      var reviewImageMarkup=settings.reviewImage
  ? '<img class="bbb__review-img" src="'+
      escapeAttr(settings.reviewImage)+
      '" alt="Bundle & Save" loading="lazy">'
  : imageMarkup(leadLine,'bbb__review-img');

      nodes.screen.innerHTML=
        '<div class="bbb__review">'+
          '<h1>'+escapeHtml(copy.reviewTitle||'Your Bundle Is Ready')+'</h1>'+
          '<p class="bbb__review-copy">'+escapeHtml(copy.reviewCopy||'')+'</p>'+
          '<div class="bbb__review-layout">'+
            '<div class="bbb__review-box">'+
              '<div class="bbb__review-head">'+
                reviewImageMarkup+
                '<div><h2 style="margin:0;color:var(--bbb-blue);font-size:17px;font-weight:900">BUNDLE &amp; SAVE <span>'+itemCount+' '+itemLabel+'</span></h2></div>'+
                reviewHeaderActions+
              '</div>'+
              '<div class="bbb__review-lines">'+
                lines.map(function(line){
                  return '<div class="bbb__review-line"><span>'+escapeHtml(lineTitle(line))+'</span><strong>'+formatMoney(line.price)+'</strong><span>x'+line.qty+'</span></div>';
                }).join('')+
              '</div>'+
            '</div>'+
            '<div class="bbb__order-box">'+
              '<h2 style="margin:0 0 18px;color:var(--bbb-blue);font-size:16px">'+escapeHtml(copy.orderDetails||'Bundle Details')+'</h2>'+
              '<div class="bbb__order-row"><span>'+escapeHtml(copy.subtotal||'Subtotal')+'</span><strong>'+formatMoney(price.subtotal)+'</strong></div>'+
              (price.discount>0
                ? '<div class="bbb__order-row bbb__order-row--saving"><span>'+escapeHtml(copy.discount||'Bundle Saving')+'</span><strong>-'+formatMoney(price.discount)+'</strong></div>'
                : ''
              )+
              '<div class="bbb__order-row"><span>'+escapeHtml(copy.total||'Total')+'</span><strong>'+formatMoney(price.total)+'</strong></div>'+
              '<button class="bbb__primary bbb__primary--complete" data-bbb-cart type="button" '+(cartEditing?'disabled':'')+'>'+(state.submittedInCart?'':'✓ ')+escapeHtml(cartButtonLabel)+'</button>'+
              (state.submittedInCart
                ? '<button class="bbb__secondary" data-bbb-edit-cart type="button" '+(cartEditing?'disabled':'')+'>'+(cartEditing?'Preparing Edit...':'Edit This Bundle')+'</button>'
                : ''
              )+
              (
  state.submittedInCart
    ? ''
    : '<button class="bbb__secondary" data-bbb-reset type="button" '+(cartEditing?'disabled':'')+'>'+
        'Start Over'+
      '</button>'
)+
              inCartNotice+
            '</div>'+
          '</div>'+
        '</div>';
    }

    function productToolbar(){
      var current=state.filter||'All';

      function option(value,label){
        return '<option value="'+escapeAttr(value)+'" '+(current===value?'selected':'')+'>'+escapeHtml(label)+'</option>';
      }

      return '<div class="bbb__toolbar bbb__toolbar--no-search">'+
        '<select class="bbb__filter-select" data-bbb-filter-select>'+
          option('All','All Products')+
          '<optgroup label="— DOG —">'+
            option('Dog Towels','Dog Towels')+
            option('Dog Drying Robes','Dog Drying Robes')+
            option('Dog Hoodies & Jumpers','Dog Hoodies & Jumpers')+
            option('Dog Treats','Dog Treats')+
          '</optgroup>'+
          '<optgroup label="— HUMAN —">'+
            option('Adult Hooded Towels','Adult Hooded Towels')+
            option('Kids & Toddler Hooded Towels','Kids & Toddler Hooded Towels')+
          '</optgroup>'+
          '<optgroup label="— FEATURED —">'+
            option('Matching Dog & Owner Sets','Matching Dog & Owner Sets')+
          '</optgroup>'+
        '</select>'+
      '</div>';
    }

    function productCard(product){
      var variant=firstVariant(product);
      var image=product.featuredImage||(variant&&variant.image);
      var disabled=settings.trackInventory&&!isAvailable(variant);
      var selected=state.lines.some(function(line){
        return line.productId===product.id;
      });
      var text=disabled
        ? (copy.noMoreStock||'No More Stock')
        : (selected
            ? (copy.added||'Add Another')
            : (hasOptions(product)
                ? (copy.chooseOptions||'Choose Options')
                : (copy.addToBundle||'Add To Bundle')
              )
          );

      return ''+
        '<article class="bbb__card" data-bbb-open-product data-bbb-product="'+product.id+'">'+
          '<div class="bbb__card-img">'+
            (image
              ? '<img src="'+escapeAttr(image)+'" alt="'+escapeAttr(product.title)+'" loading="lazy">'
              : '<div class="bbb__fallback">'+escapeHtml(product.title)+'</div>'
            )+
          '</div>'+
          '<h2 class="bbb__title">'+escapeHtml(product.title)+'</h2>'+
          '<div class="bbb__price">'+
            (variant&&variant.compareAt&&variant.compareAt>variant.price
              ? '<span class="bbb__compare">'+formatMoney(variant.compareAt)+'</span>'
              : ''
            )+
            '<span>'+formatMoney(variant?variant.price:product.price)+'</span>'+
          '</div>'+
          '<button type="button" class="bbb__soft" data-bbb-action data-bbb-product="'+product.id+'" '+(disabled?'disabled':'')+'>'+escapeHtml(text)+'</button>'+
        '</article>';
    }

    function renderTray(){
      var lines=cartLines();
      var price=pricing();

      nodes.count.hidden=false;
      nodes.count.setAttribute('aria-hidden','false');
      nodes.count.textContent=lines.reduce(function(total,line){
        return total+(+line.qty||1);
      },0);

      nodes.total.innerHTML=
        '<span class="bbb__total-price">'+formatMoney(price.total)+'</span>'+
        (price.discount>0
          ? '<span class="bbb__total-save">'+price.percent+'% off · Saving '+formatMoney(price.discount)+'</span>'
          : ''
        );

      var trayMessage='';

      if(state.submittedInCart){
  trayMessage='This bundle is already in your cart.';
}else if(state.review){
  trayMessage=price.combinedEligible>0
    ? discountMessage(price.combinedEligible)
    : 'Review your bundle.';
}else{
  trayMessage=price.combinedEligible>0
    ? discountMessage(price.combinedEligible)
    : 'Add products to unlock bundle savings.';
}
      nodes.discount.innerHTML=
        escapeHtml(trayMessage)+
        '<div class="bbb__bar"><span style="--p:'+discountProgress(price.combinedEligible)+'%"></span></div>';

      nodes.trayItems.innerHTML=lines.map(function(line,index){
        var removeButton=state.submittedInCart
          ? ''
          : '<button type="button" class="bbb__tray-remove" data-bbb-remove-tray="'+index+'" aria-label="Remove '+escapeAttr(lineTitle(line))+'">&times;</button>';

        return '<div class="bbb__tray-item bbb__tray-line">'+
          removeButton+
          imageMarkup(line,'')+
          '<div><strong>'+escapeHtml(truncate(lineTitle(line),32))+'</strong><br>'+formatMoney(line.price)+' x'+line.qty+'</div>'+
        '</div>';
      }).join('');

      bindTraySwipeHint(lines);
trackDiscountTier(price);
    }

    function bindTraySwipeHint(lines){
      var trayInner=nodes.trayItems.closest('.bbb__tray-inner');

      if(!trayInner){
        return;
      }

      trayInner.classList.remove('bbb__tray-inner--scrollhint');

      requestAnimationFrame(function(){
        if(!nodes.trayItems||!trayInner)return;

        /*
          Three or more tray items deliberately use slightly narrower
          cards so a piece of the next item remains visible. That is
          enough of a horizontal-scroll cue without an extra arrow.
        */
        if(lines.length>=3&&nodes.trayItems.scrollWidth>nodes.trayItems.clientWidth+8){
          trayInner.classList.add('bbb__tray-inner--scrollhint');
        }
      });
    }

    function updateTrayButton(){
      var button=root.querySelector('[data-bbb-next]');

      if(!button)return;

      if(!button.getAttribute('data-bbb-next-label')){
        button.setAttribute('data-bbb-next-label',(button.textContent||'Review').trim()||'Review');
      }

      var nextLabel=button.getAttribute('data-bbb-next-label')||'Review';
      var completeLabel=button.getAttribute('data-bbb-complete-label')||'✓ Add Bundle To Cart';

      if(state.review){
        button.classList.add('bbb__nav--complete');
        button.textContent=state.submittedInCart?'Return to Cart':completeLabel;
        button.setAttribute('aria-label',state.submittedInCart?'Return to Cart':'Add Bundle To Cart');
      }else{
        button.classList.remove('bbb__nav--complete');
        button.textContent=nextLabel;
        button.setAttribute('aria-label',nextLabel);
      }
    }

    function removeTrayLine(index){
      index=parseInt(index,10);

      if(isNaN(index))return;

      var lines=cartLines();
      var line=lines[index];

      if(!line)return;

      state.lines=state.lines.filter(function(item){
  return item!==line;
});

var removedProduct=findProduct(line.productId);

trackBuilderEvent('builder_product_remove',Object.assign({
  product_id:String(line.productId||''),
  variant_id:String(line.variantId||''),
  product_title:line.title||'',
  quantity_removed:+line.qty||1,
  unit_price:analyticsMoney(line.price)
},matchmakerRecommendationAnalytics(removedProduct,'')));

render();
showToast('Removed from bundle.');
    }

    function handleClick(event){
      var element;

      if(element=event.target.closest('[data-bbb-size-guide-open]')){
        event.preventDefault();
        openSizeGuide(state.modal.product);
        return;
      }

      if(element=event.target.closest('[data-bbb-size-guide-close]')){
        event.preventDefault();
        closeSizeGuide();
        return;
      }

      if(element=event.target.closest('[data-bbb-size-guide-calc]')){
        event.preventDefault();
        calculateSize();
        return;
      }

      if(event.target.hasAttribute&&event.target.hasAttribute('data-bbb-size-guide-overlay')){
        closeSizeGuide();
        return;
      }

      if(element=event.target.closest('[data-bbb-remove-tray]')){
        event.preventDefault();
        event.stopPropagation();

        if(state.submittedInCart){
          showToast('This bundle is already in your cart. Choose Create New Bundle to make another.');
          return;
        }

        removeTrayLine(element.getAttribute('data-bbb-remove-tray'));
        return;
      }

      if(element=event.target.closest('[data-bbb-step]')){
        var stepIndex=+element.dataset.bbbStep;

        if(state.submittedInCart){
          showToast('This bundle is already in your cart. Choose Edit This Bundle to change it.');
          return;
        }

        if(stepIndex===0){
          state.step=0;
          state.review=false;
          resetFilter();
          replaceBuilderHistory(false);
          render();
          scrollToBuilder();
          return;
        }

        if(stepIndex===1&&canContinue(true)){
          state.step=1;
          state.review=true;
          resetFilter();
          replaceBuilderHistory(false);
          render();
          scrollToBuilder();
          return;
        }
      }

      if(element=event.target.closest('[data-bbb-matchmaker-action]')){
        event.preventDefault();
        event.stopPropagation();

        var recommendationEntry=matchmakerEntryByKey(
          element.dataset.bbbRecommendationKey||''
        );

        if(recommendationEntry){
          openMatchmakerRecommendation(recommendationEntry);
        }

        return;
      }

      if(element=event.target.closest('[data-bbb-open-product]')){
        if(!event.target.closest('[data-bbb-action]')){
          var productFromCard=findProduct(element.dataset.bbbProduct);

          if(productFromCard){
            openModal(productFromCard);
            return;
          }
        }
      }

      if(element=event.target.closest('[data-bbb-action]')){
        event.preventDefault();
        event.stopPropagation();

        var product=findProduct(element.dataset.bbbProduct);

        if(!product)return;

        hasOptions(product)
          ? openModal(product)
          : addSimple(product);

        return;
      }

      if(event.target.closest('[data-bbb-back]')){
        if(state.submittedInCart){
          location.href='/cart';
          return;
        }

        goBack();
        return;
      }

      if(event.target.closest('[data-bbb-next]')){
        if(state.review){
          addToCart();
        }else{
          goForward();
        }

        return;
      }

      if(event.target.closest('[data-bbb-close]')||event.target===nodes.modal){
        event.preventDefault();
        event.stopPropagation();
        closeModal(false);
        return;
      }

      if(element=event.target.closest('[data-bbb-qty]')){
        if(state.modal.matchmakerLockedQuantity){
          return;
        }

        state.modal.qty=Math.max(1,state.modal.qty+(+element.dataset.bbbQty));
        renderModal();
        return;
      }

      if(element=event.target.closest('[data-bbb-option]')){
        if(
          element.disabled||
          element.getAttribute('aria-disabled')==='true'||
          element.classList.contains('is-sold-out')
        ){
          return;
        }

        var optionIndex=+element.dataset.bbbOption;

        state.modal.options[optionIndex]=element.dataset.bbbValue;
        syncModalOptions(state.modal.product,optionIndex);
        state.modal.img=0;
        renderModal();
        return;
      }

      if(element=event.target.closest('[data-bbb-modal-add]')){
        event.preventDefault();
        event.stopPropagation();
        addModalProduct();
        return;
      }

      if(element=event.target.closest('[data-bbb-thumb]')){
        state.modal.img=+element.dataset.bbbThumb;
        renderModal();
        return;
      }

      if(event.target.closest('[data-bbb-edit-cart]')){
        editSubmittedBundle();
        return;
      }

      if(event.target.closest('[data-bbb-edit]')){
        if(state.submittedInCart){
          showToast('This bundle is already in your cart. Choose Edit This Bundle to change it.');
          return;
        }

        state.step=0;
        state.review=false;
        resetFilter();
        replaceBuilderHistory(false);
        render();
        scrollToBuilder();
        return;
      }

      if(event.target.closest('[data-bbb-reset]')){
  if(cartEditing)return;

  if(
    !state.submittedInCart&&
    state.lines.length
  ){
    var confirmed=window.confirm(
      'Start over?\n\n'+
      'This will remove all products currently selected in your bundle.'
    );

    if(!confirmed)return;
  }

  resetBuilder();
  return;
}

      if(event.target.closest('[data-bbb-cart]')){
        addToCart();
      }
    }

    function handleChange(event){
      var element;

      if(element=event.target.closest('[data-bbb-filter-select]')){
        state.filter=element.value||'All';
        renderProducts();
        renderTray();
        updateTrayButton();
        saveState();
      }
    }

    function openModal(product,recommendationEntry){
      recommendationEntry=recommendationEntry||matchmakerEntryForProduct(product);

      var variant=firstVariant(product);
      var optionDefinitions=realOptions(product);
      var recommendedRemaining=recommendationEntry
        ? Math.max(1,remainingMatchmakerQuantity(recommendationEntry))
        : 1;
      var lockRecommendedQuantity=!!(
        recommendationEntry&&
        hasOptions(product)&&
        Math.max(1,+recommendationEntry.quantity||1)>1
      );

      state.modal={
        product:product,
        qty:recommendationEntry
          ? (lockRecommendedQuantity?1:recommendedRemaining)
          : 1,
        options:variant
          ? optionDefinitions.map(function(option){
              var actualIndex=product.options.indexOf(option);

              return variant.options[actualIndex];
            })
          : [],
        img:0,
        matchmakerRecommendationKey:recommendationEntry
          ? recommendationEntry.key
          : '',
        matchmakerRecommendationHandle:recommendationEntry
          ? recommendationEntry.handle
          : '',
        matchmakerTargetQuantity:recommendationEntry
          ? Math.max(1,+recommendationEntry.quantity||1)
          : 0,
        matchmakerLockedQuantity:lockRecommendedQuantity,
        matchmakerSequence:lockRecommendedQuantity,
        matchmakerSequenceOpenedAt:recommendationEntry
          ? configuredMatchmakerQuantity(recommendationEntry)
          : 0
      };

      pushBuilderHistory(true);
      renderModal();
      nodes.modal.classList.add('is-open');
      nodes.modal.setAttribute('aria-hidden','false');

      setTimeout(function(){
        var panel=nodes.modal.querySelector('.bbb__modal');

        if(panel)panel.scrollTop=0;
        nodes.modal.scrollTop=0;
      },0);
    }

    function closeModal(fromHistory){
      var shouldStepBack=
        !fromHistory&&
        window.history&&
        window.history.state&&
        window.history.state.bbbKey===historyStateKey&&
        window.history.state.bbbModal===true;

      nodes.modal.classList.remove('is-open');
      nodes.modal.setAttribute('aria-hidden','true');
      state.modal.product=null;
      closeSizeGuide();

      if(shouldStepBack){
        ignoreNextPopstate=true;
        window.history.back();
      }
    }

    function renderModal(){
      var product=state.modal.product;

      if(!product)return;

      var variant=selectedVariant(product);
      var images=modalImages(product,variant);
      var imageUrl=images[state.modal.img]||product.featuredImage||'';
      var imageElement=root.querySelector('[data-bbb-modal-image]');

      imageElement.src=imageUrl;
      imageElement.hidden=!imageUrl;
      imageElement.alt=product.title||'';

      var modalTitle=root.querySelector(
  '[data-bbb-modal-title]'
);

modalTitle.textContent=product.title||'';

root.querySelectorAll(
  '.bbb__modal-subtitle'
).forEach(function(element){
  element.remove();
});

if(product.builderSubtitle){
  modalTitle.insertAdjacentHTML(
    'afterend',
    '<div class="bbb__modal-subtitle">'+
      escapeHtml(product.builderSubtitle)
        .replace(/\r?\n/g,'<br>')+
    '</div>'
  );
}

var priceElement=root.querySelector(
  '[data-bbb-modal-price]'
);

      priceElement.innerHTML=
        (variant&&variant.compareAt&&variant.compareAt>variant.price
          ? '<span class="bbb__compare">'+formatMoney(variant.compareAt)+'</span> '
          : ''
        )+
        '<span>'+formatMoney(variant?variant.price:product.price)+'</span>';

      root.querySelectorAll('.bbb__size-guide,.bbb__modal-description').forEach(function(element){
        element.remove();
      });

      if(needsSizeGuide(product)){
        priceElement.insertAdjacentHTML(
          'afterend',
          '<button type="button" class="bbb__size-guide" data-bbb-size-guide-open>← Find My Size</button>'
        );
      }

      root.querySelector('[data-bbb-qty-value]').textContent=state.modal.qty;

      root.querySelectorAll('.bbb__matchmaker-modal-note').forEach(function(element){
        element.remove();
      });

      var qtyRow=root.querySelector('.bbb__qty-row');

      if(qtyRow){
        qtyRow.hidden=!!state.modal.matchmakerLockedQuantity;
        qtyRow.style.display=state.modal.matchmakerLockedQuantity?'none':'';

        if(state.modal.matchmakerRecommendationKey){
          var modalEntry=matchmakerEntryByKey(
            state.modal.matchmakerRecommendationKey
          );
          var modalDone=modalEntry
            ? configuredMatchmakerQuantity(modalEntry)
            : 0;
          var modalTarget=modalEntry
            ? Math.max(1,+modalEntry.quantity||1)
            : Math.max(1,+state.modal.matchmakerTargetQuantity||1);
          var modalChoiceType=modalEntry
            ? matchmakerChoiceType(modalEntry)
            : 'options';
          var modalNumber=Math.min(modalDone+1,modalTarget);
          var modalItemLabel=modalChoiceType==='colour'
            ? 'Towel'
            : (modalChoiceType==='size'?'Robe':'Item');
          var modalInstruction=modalChoiceType==='colour'
            ? 'Choose a colour'
            : (modalChoiceType==='size'?'Choose a size':'Choose your options');
          var savedSelections=modalEntry
            ? configuredMatchmakerSelections(modalEntry)
            : [];
          var progressHtml='';

          for(var progressIndex=1;progressIndex<=modalTarget;progressIndex+=1){
            var progressDone=progressIndex<=modalDone;
            var progressActive=!progressDone&&progressIndex===modalNumber;

            progressHtml+=
              '<span style="'+
                'display:inline-flex;align-items:center;justify-content:center;'+
                'min-width:30px;height:30px;padding:0 8px;border-radius:999px;'+
                'font-size:11px;font-weight:900;'+
                (progressDone
                  ? 'background:#18864b;color:#fff;'
                  : progressActive
                    ? 'background:#fff1e8;color:#9e4200;border:1px solid #ef8a31;'
                    : 'background:#eef4f6;color:#617b8a;border:1px solid rgba(7,61,89,.10);'
                )+
              '">'+
                (progressDone?'✓ ':'')+progressIndex+
              '</span>';
          }

          var savedCopy='';

          var selectionCopy=savedSelections.length
            ? '<div style="margin-top:6px;color:#617b8a;font-size:10px;line-height:1.35;">Saved: '+
                escapeHtml(savedSelections.join(' · '))+
              '</div>'
            : '';

          var noteHtml=
            '<div class="bbb__matchmaker-modal-note" style="'+
              'padding:12px 13px;border:1px solid rgba(7,125,171,.18);'+
              'border-radius:12px;background:#f3fbfe;'+
            '">'+
              '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">'+
                '<strong style="color:#073d59;font-size:13px;">'+
                  escapeHtml(
                    state.modal.matchmakerLockedQuantity
                      ? modalItemLabel+' '+modalNumber+' of '+modalTarget+' — '+modalInstruction
                      : 'Matchmaker pick — '+modalInstruction
                  )+
                '</strong>'+
                (state.modal.matchmakerLockedQuantity
                  ? '<div style="display:flex;gap:6px;">'+progressHtml+'</div>'
                  : ''
                )+
              '</div>'+
              savedCopy+
              selectionCopy+
            '</div>';

          qtyRow.insertAdjacentHTML(
            'beforebegin',
            noteHtml
          );
        }
      }

      root.querySelector('[data-bbb-thumbs]').innerHTML=images.map(function(image,index){
        return '<button class="bbb__thumb '+(index===state.modal.img?'is-active':'')+'" type="button" data-bbb-thumb="'+index+'"><img src="'+escapeAttr(image)+'" alt=""></button>';
      }).join('');

      root.querySelector('[data-bbb-options]').innerHTML=
        realOptions(product).map(function(option,optionIndex){
          return '<div class="bbb__option">'+
            '<span class="bbb__option-label">'+escapeHtml(option.name)+'</span>'+
            '<div class="bbb__swatches">'+
              option.values.map(function(value){
                var soldOut=
                  settings.trackInventory&&
                  !optionValueAvailable(product,optionIndex,value);

                var active=
                  state.modal.options[optionIndex]===value;

                return ''+
                  '<button '+
                    'type="button" '+
                    'class="bbb__swatch '+
                      (active?'is-active ':'')+
                      (soldOut?'is-sold-out':'')+
                    '" '+
                    'data-bbb-option="'+optionIndex+'" '+
                    'data-bbb-value="'+escapeAttr(value)+'" '+
                    (soldOut
                      ? 'disabled aria-disabled="true"'
                      : 'aria-disabled="false"'
                    )+
                  '>'+
                    '<span class="bbb__swatch-value">'+escapeHtml(value)+'</span>'+
                    (soldOut
                      ? '<span class="bbb__swatch-stock">Sold out</span>'
                      : ''
                    )+
                  '</button>';
              }).join('')+
            '</div>'+
          '</div>';
        }).join('');

      var addButton=root.querySelector('[data-bbb-modal-add]');
      var unavailable=
        !variant||
        (
          settings.trackInventory&&
          !isAvailable(variant)
        );

      if(addButton){
        if(!addButton.dataset.bbbAvailableLabel){
          addButton.dataset.bbbAvailableLabel=
            (addButton.textContent||'Add To Bundle').trim();
        }

        addButton.disabled=unavailable;
        addButton.setAttribute(
          'aria-disabled',
          unavailable?'true':'false'
        );

        var matchmakerSequenceButton=
          !!(
            state.modal.matchmakerLockedQuantity&&
            state.modal.matchmakerRecommendationKey
          );

        if(matchmakerSequenceButton&&!unavailable){
          addButton.style.background='#ef6c00';
          addButton.style.borderColor='#ef6c00';
          addButton.style.color='#fff';
          addButton.style.opacity='1';
        }else{
          addButton.style.removeProperty('background');
          addButton.style.removeProperty('border-color');
          addButton.style.removeProperty('color');
          addButton.style.removeProperty('opacity');
        }

        if(unavailable){
          addButton.textContent='Choose an available option';
        }else if(
          matchmakerSequenceButton
        ){
          var buttonEntry=matchmakerEntryByKey(
            state.modal.matchmakerRecommendationKey
          );
          var buttonDone=buttonEntry
            ? configuredMatchmakerQuantity(buttonEntry)
            : 0;
          var buttonTarget=buttonEntry
            ? Math.max(1,+buttonEntry.quantity||1)
            : Math.max(1,+state.modal.matchmakerTargetQuantity||1);

          addButton.textContent=buttonEntry
            ? matchmakerSequenceButtonLabel(
                buttonEntry,
                buttonDone,
                buttonTarget
              )
            : addButton.dataset.bbbAvailableLabel;
        }else{
          addButton.textContent=addButton.dataset.bbbAvailableLabel;
        }
      }

      var descriptionHtml=
        product.builderDescriptionHtml||
        product.descriptionHtml||
        (product.description?'<p>'+escapeHtml(product.description)+'</p>':'');

      if(addButton&&descriptionHtml){
        addButton.insertAdjacentHTML(
          'afterend',
          '<div class="bbb__modal-description">'+descriptionHtml+'</div>'
        );
      }
    }

    function needsSizeGuide(product){
      return !!(product&&product.sizeGuide&&product.sizeGuide.contentHtml);
    }

    function openSizeGuide(product){
      var existing=root.querySelector('[data-bbb-size-guide-overlay]');

      if(existing){
        existing.remove();
      }

      var markup=sizeGuideMarkup(product);

      if(!markup){
        showToast('Size guide is not available for this product.');
        return;
      }

      root.insertAdjacentHTML('beforeend',markup);
      existing=root.querySelector('[data-bbb-size-guide-overlay]');
      existing.classList.add('is-open');
      existing.setAttribute('aria-hidden','false');
    }

    function closeSizeGuide(){
      var existing=root.querySelector('[data-bbb-size-guide-overlay]');

      if(!existing)return;

      existing.classList.remove('is-open');
      existing.setAttribute('aria-hidden','true');
    }

    function sizeGuideMarkup(product){
      if(!product||!product.sizeGuide||!product.sizeGuide.contentHtml)return '';

      var showCalculator=isDogRobeSizeGuide(product);

      return ''+
        '<div class="bbb__size-guide-overlay" data-bbb-size-guide-overlay aria-hidden="true">'+
          '<div class="bbb__size-guide-panel" role="dialog" aria-modal="true">'+
            '<button type="button" class="bbb__size-guide-close" data-bbb-size-guide-close aria-label="Close size guide">&times;</button>'+
            '<h2>'+escapeHtml(product.sizeGuide.title||'Size Guide')+'</h2>'+
            (showCalculator
              ? '<div class="bbb__size-guide-calculator">'+
                  '<p>Measure from the base of your dog’s neck to the base of their tail.</p>'+
                  '<img class="bbb__size-guide-measure-img" src="https://cdn.shopify.com/s/files/1/0496/0390/3637/files/Size-Guide-For-Dog-Robe-image.jpg?v=1764283741" alt="Dog measuring guide" loading="lazy">'+
                  '<div class="bbb__size-guide-calc">'+
                    '<input type="number" inputmode="decimal" data-bbb-size-guide-input placeholder="Dog length in cm">'+
                    '<button type="button" data-bbb-size-guide-calc>Calculate</button>'+
                  '</div>'+
                  '<div class="bbb__size-guide-result" data-bbb-size-guide-result hidden></div>'+
                '</div>'
              : ''
            )+
            '<div class="bbb__size-guide-page-content">'+product.sizeGuide.contentHtml+'</div>'+
          '</div>'+
        '</div>';
    }

    function isDogRobeSizeGuide(product){
      if(!product||!product.sizeGuide)return false;

      var guideText=[
        product.sizeGuide.title||'',
        product.sizeGuide.url||'',
        product.sizeGuide.contentHtml||''
      ].join(' ').toLowerCase();

      if(guideText.indexOf('dachshund')>-1)return false;
      if(guideText.indexOf('hoodie')>-1)return false;
      if(guideText.indexOf('jumper')>-1)return false;
      if(guideText.indexOf('adult')>-1)return false;
      if(guideText.indexOf('kids')>-1)return false;
      if(guideText.indexOf('toddler')>-1)return false;

      return guideText.indexOf('dog coat')>-1||
        guideText.indexOf('dog robe')>-1||
        guideText.indexOf('drying coat')>-1||
        guideText.indexOf('drying robe')>-1||
        guideText.indexOf('dog_coat_size_guide')>-1||
        guideText.indexOf('dog-coat-size-guide')>-1||
        guideText.indexOf('dog coat size guide')>-1||
        guideText.indexOf('size-guide-for-dog-robe')>-1;
    }

    function calculateSize(){
      var overlay=root.querySelector('[data-bbb-size-guide-overlay]');

      if(!overlay)return;

      var input=overlay.querySelector('[data-bbb-size-guide-input]');
      var result=overlay.querySelector('[data-bbb-size-guide-result]');
      var length=parseFloat(input&&input.value);

      if(!length){
        showToast('Please enter your dog’s length in cm.');
        return;
      }

      var size='';
      var range='';
      var note='';

      if(length<16){
  size='Below XXS';
  range='Less than 16cm';
}else if(length<21){
  size='XXS';
  range='Fits 16cm–21cm';
  note='This size is for the tiniest teacup dogs under 3kg. If they are a little bigger, XS is usually safer.';
}else if(length<26){
  size='XS';
  range='Fits 21cm–26cm';
}else if(length<32){
  size='S';
  range='Fits 26cm–32cm';
}else if(length<40){
  size='M';
  range='Fits 32cm–40cm';
}else if(length<46){
  size='L';
  range='Fits 40cm–46cm';
}else if(length<52){
  size='XL';
  range='Fits 46cm–52cm';
}else if(length<60){
  size='XXL';
  range='Fits 52cm–60cm';
}else if(length<68){
  size='3XL';
  range='Fits 60cm–68cm';
}else if(length<=78){
  size='4XL';
  range='Fits 68cm–78cm';
}else{
  size='Over 4XL';
  range='Needs custom fit';
}

      result.hidden=false;
      result.innerHTML=
        '<div class="bbb__size-result-label">Recommended Size</div>'+
        '<div class="bbb__size-result-size">'+escapeHtml(size)+'</div>'+
        '<div class="bbb__size-result-range">'+escapeHtml(range)+'</div>'+
        (note?'<div class="bbb__size-result-note">'+escapeHtml(note)+'</div>':'');
    }

    function addSimple(product,recommendationEntry){
      recommendationEntry=recommendationEntry||matchmakerEntryForProduct(product);

      var variant=firstVariant(product);

      if(!variant||settings.trackInventory&&!isAvailable(variant)){
        showToast(copy.noMoreStock||'No More Stock');
        return;
      }

      var qty=recommendationEntry
        ? Math.max(1,remainingMatchmakerQuantity(recommendationEntry))
        : 1;

      addLine(
        product,
        variant,
        qty,
        recommendationEntry?recommendationEntry.key:''
      );
      refreshVisibleButtons();
      renderTray();
      updateTrayButton();
      saveState();

      if(recommendationEntry){
        afterMatchmakerRecommendationAdded(recommendationEntry);
      }
    }

    function addModalProduct(){
      var product=state.modal.product;
      var variant=selectedVariant(product);
      var qty=state.modal.qty;
      var recommendationEntry=state.modal.matchmakerRecommendationKey
        ? matchmakerEntryByKey(state.modal.matchmakerRecommendationKey)
        : matchmakerEntryForProduct(product);
      var isMatchmakerSequence=!!(
        recommendationEntry&&
        state.modal.matchmakerLockedQuantity
      );

      if(!variant||settings.trackInventory&&!isAvailable(variant)){
        showToast('Please select an available option.');
        return;
      }

      addLine(
        product,
        variant,
        qty,
        recommendationEntry?recommendationEntry.key:''
      );
      refreshVisibleButtons();
      renderTray();
      updateTrayButton();
      saveState();

      if(isMatchmakerSequence){
        var sequenceTarget=Math.max(
          1,
          +recommendationEntry.quantity||1
        );
        var sequenceDone=Math.min(
          sequenceTarget,
          configuredMatchmakerQuantity(recommendationEntry)
        );
        var sequenceRemaining=Math.max(
          0,
          sequenceTarget-sequenceDone
        );

        if(sequenceRemaining>0){
          state.modal.qty=1;
          state.modal.img=0;
          renderModal();

          var modalPanel=nodes.modal.querySelector('.bbb__modal');
          var modalNote=nodes.modal.querySelector('.bbb__matchmaker-modal-note');

          if(modalPanel&&modalNote){
            try{
              modalPanel.scrollTo({
                top:Math.max(0,modalNote.offsetTop-12),
                behavior:'smooth'
              });
            }catch(error){
              modalPanel.scrollTop=Math.max(0,modalNote.offsetTop-12);
            }
          }

          showToast(
            'Now choose your '+
            matchmakerOrdinal(sequenceDone+1)+' '+
            matchmakerChoiceType(recommendationEntry)+'.'
          );
          return;
        }
      }

      closeModal(false);

      if(recommendationEntry){
        afterMatchmakerRecommendationAdded(recommendationEntry);
      }else{
        renderProducts();
        renderTray();
        updateTrayButton();
        saveState();
      }
    }

    function refreshVisibleButtons(){
      root.querySelectorAll('[data-bbb-action][data-bbb-product]').forEach(function(button){
        var product=findProduct(button.dataset.bbbProduct);

        if(!product)return;

        var variant=firstVariant(product);
        var disabled=settings.trackInventory&&!isAvailable(variant);
        var selected=state.lines.some(function(line){
          return line.productId===product.id;
        });
        var text=disabled
          ? (copy.noMoreStock||'No More Stock')
          : (selected
              ? (copy.added||'Add Another')
              : (hasOptions(product)
                  ? (copy.chooseOptions||'Choose Options')
                  : (copy.addToBundle||'Add To Bundle')
                )
            );

        button.disabled=disabled;
        button.textContent=text;
      });
    }

    function addLine(product,variant,qty,recommendationKey){
  var key='product:'+variant.id;
  var recommendationAnalytics=
    matchmakerRecommendationAnalytics(product,recommendationKey);

  var existing=state.lines.find(function(line){
    return line.key===key;
  });

  if(existing){
    existing.qty+=qty;

    trackBuilderEvent('builder_product_add',Object.assign({
      product_id:String(product.id),
      variant_id:String(variant.id),
      product_title:product.title,
      quantity_added:qty,
      line_quantity:existing.qty,
      unit_price:analyticsMoney(variant.price)
    },recommendationAnalytics));

    return;
  }

  state.lines.push({
    key:key,
    group:'product',
    productId:product.id,
    variantId:variant.id,
    title:product.title,
    variantTitle:cleanVariantTitle(variant.title),
    price:+variant.price,
    image:variant.image||product.featuredImage||'',
    qty:qty
  });

  trackBuilderEvent('builder_product_add',Object.assign({
    product_id:String(product.id),
    variant_id:String(variant.id),
    product_title:product.title,
    quantity_added:qty,
    line_quantity:qty,
    unit_price:analyticsMoney(variant.price)
  },recommendationAnalytics));
}

    function goForward(){
  if(!canContinue(false))return;

  state.step=1;
  state.review=true;
  resetFilter();
  pushBuilderHistory(false);
  render();

  trackBuilderEvent('builder_review_view',{
    review_item_count:builderItemCount(),
    recommended_kit_ready:matchmakerContext
      ? (matchmakerRecommendationsReady()?'yes':'no')
      : 'not_applicable'
  });

  scrollToBuilder();
}

    function goBack(){
      var currentHistory=window.history&&window.history.state
        ? window.history.state
        : {};

      if(currentHistory.bbbKey===historyStateKey&&state.review){
        window.history.back();
        return;
      }

      state.step=0;
      state.review=false;
      resetFilter();
      replaceBuilderHistory(false);
      render();
      scrollToBuilder();
    }

    function builderHistoryState(modalOpen){
      var current=window.history&&window.history.state
        ? window.history.state
        : {};

      return Object.assign({},current,{
        bbbKey:historyStateKey,
        bbbStep:state.step,
        bbbReview:state.review,
        bbbModal:!!modalOpen
      });
    }

    function replaceBuilderHistory(modalOpen){
      if(!window.history||!window.history.replaceState)return;

      window.history.replaceState(
        builderHistoryState(modalOpen),
        '',
        window.location.href
      );
    }

    function pushBuilderHistory(modalOpen){
      if(!window.history||!window.history.pushState)return;

      window.history.pushState(
        builderHistoryState(modalOpen),
        '',
        window.location.href
      );
    }

    function canContinue(silent){
      var itemCount=state.lines.reduce(function(total,line){
        return total+Math.max(1,+line.qty||1);
      },0);

      if(itemCount<2){
        if(!silent){
          showToast(
            copy.selectProductWarning||
            'Add at least 2 products to your bundle before reviewing.'
          );
        }

        return false;
      }

      return true;
    }

    function firstUnavailableLine(){
      if(!settings.trackInventory){
        return null;
      }

      return state.lines.find(function(line){
        var product=findProduct(line.productId);

        if(!product){
          return true;
        }

        var variant=product.variants.find(function(item){
          return +item.id===+line.variantId;
        });

        return !variant||!isAvailable(variant);
      })||null;
    }

    async function addToCart(){
      if(cartEditing)return;

      if(state.submittedInCart&&state.submittedBundleId){
        location.href='/cart';
        return;
      }

      if(cartSubmitting)return;
      if(!canContinue(false))return;

      var unavailableLine=firstUnavailableLine();

      if(unavailableLine){
        showToast(
          lineTitle(unavailableLine)+
          ' has sold out. Please choose another option.'
        );

        return;
      }

      cartSubmitting=true;

/*
  Recheck the cart immediately before calculating the tier,
  in case the cart changed while the builder was open.
*/
await refreshExistingBuilderValue();

var price=pricing();
var bundleId='bundle-'+Date.now();
      var lines=cartLines();
      var summary=lines.map(lineTitle).join('\n');

      var items=lines.map(function(line,index){
        var properties={
          'Bundle Builder':'Yes',
          'Bundle ID':bundleId
        };

        if(index===0){
  properties['Bundle Items']=summary;
}

        if(matchmakerContext){
          var lineProduct=findProduct(line.productId);
          var lineRecommendation=matchmakerEntryForProduct(lineProduct);

          properties['_Matchmaker']='Yes';
          properties['_Matchmaker Session']=matchmakerContext.sessionId||'';
          properties['_Matchmaker Item']=lineRecommendation
            ? lineRecommendation.key
            : 'extra';

          if(index===0){
            properties['_Matchmaker Recommendations']=
              matchmakerContext.entries
                .map(function(entry){ return entry.key; })
                .join(',');
            properties['_Matchmaker Breed']=matchmakerContext.breedName||'';
            properties['_Matchmaker Path']='bundle_builder';
          }
        }

        return {
          id:+line.variantId,
          quantity:+line.qty,
          properties:properties
        };
      });

      window.clearTimeout(loadingDelayTimer);

      loadingDelayTimer=window.setTimeout(function(){
        loading(true);
      },400);

      try{
        var response=await fetch('/cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({items:items})
        });

        if(!response.ok){
  throw new Error(await response.text());
}

window.clearTimeout(loadingDelayTimer);
loadingDelayTimer=null;

/*
  Record only successful bundle submissions.
*/
await trackBuilderEvent('builder_add_to_cart',{
  bundle_id:bundleId,
  submitted_item_count:builderItemCount(),
  submitted_value:analyticsMoney(price.subtotal),
  submitted_discount_percent:+price.percent||0,
  submitted_discount_value:analyticsMoney(price.discount),
  recommended_kit_ready:matchmakerContext
    ? (matchmakerRecommendationsReady()?'yes':'no')
    : 'not_applicable',
  destination:
    settings.redirectTo==='checkout'
      ? 'checkout'
      : 'cart'
});

var destination=settings.redirectTo==='checkout'?'/checkout':'/cart';
        var code=price.tier&&price.tier.code?price.tier.code:'';

        state.submittedBundleId=bundleId;
        state.submittedInCart=true;
        state.step=1;
        state.review=true;
        saveState();

        location.href=settings.enableDiscountRedirect&&code
          ? '/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(destination)
          : destination;
      }catch(error){
        window.clearTimeout(loadingDelayTimer);
        loadingDelayTimer=null;
        cartSubmitting=false;
        loading(false);

        console.error('Bundle add to cart failed',error,{items:items});
        showToast('Something went wrong adding this bundle to the cart.');
      }
    }

    async function verifySubmittedBundle(){
      if(!state.submittedBundleId){
        state.submittedInCart=false;
        return;
      }

      try{
        var response=await fetch('/cart.js',{
          method:'GET',
          headers:{
            'Accept':'application/json'
          },
          cache:'no-store'
        });

        if(!response.ok){
          throw new Error(await response.text());
        }

        var cart=await response.json();
        var exists=(cart.items||[]).some(function(item){
          var properties=item&&item.properties?item.properties:{};

          return String(properties['Bundle ID']||'')===String(state.submittedBundleId);
        });

        state.submittedInCart=exists;

        if(exists){
          state.step=1;
          state.review=true;
        }else{
          state.submittedBundleId='';
        }

        replaceBuilderHistory(false);
        render();

        if(exists){
          scrollToBuilder();
        }
      }catch(error){
        console.warn('Bundle cart check failed',error);

        if(state.submittedBundleId){
          state.submittedInCart=true;
          state.step=1;
          state.review=true;
          replaceBuilderHistory(false);
          render();
        }
      }
    }

    async function editSubmittedBundle(){
      if(cartEditing)return;

      if(!state.submittedBundleId){
        state.submittedInCart=false;
        state.review=false;
        state.step=0;
        replaceBuilderHistory(false);
        render();
        scrollToBuilder();
        return;
      }

      var confirmed=window.confirm(
        'Edit this bundle?\n\n'+
        'It will be temporarily removed from your cart while you make changes. '+
        'Your current selections will stay saved in the builder.'
      );

      if(!confirmed)return;

      cartEditing=true;
      render();

      try{
        var cartResponse=await fetch('/cart.js',{
          method:'GET',
          headers:{
            'Accept':'application/json'
          },
          cache:'no-store'
        });

        if(!cartResponse.ok){
          throw new Error(await cartResponse.text());
        }

        var cart=await cartResponse.json();
        var matching=(cart.items||[]).filter(function(item){
          var properties=item&&item.properties?item.properties:{};

          return String(properties['Bundle ID']||'')===String(state.submittedBundleId);
        });

        if(!matching.length){
          state.submittedBundleId='';
          state.submittedInCart=false;
          state.review=false;
          state.step=0;
          cartEditing=false;
          saveState();
          replaceBuilderHistory(false);
          render();
          scrollToBuilder();
          showToast('This bundle was no longer in the cart. You can edit it now.');
          return;
        }

        var updates={};

        matching.forEach(function(item){
          if(item&&item.key){
            updates[String(item.key)]=0;
          }
        });

        if(!Object.keys(updates).length){
          throw new Error('Matching bundle lines did not include cart line keys.');
        }

        var updateResponse=await fetch('/cart/update.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({updates:updates})
        });

        if(!updateResponse.ok){
          throw new Error(await updateResponse.text());
        }

        var updatedCart=await updateResponse.json();
        var stillExists=(updatedCart.items||[]).some(function(item){
          var properties=item&&item.properties?item.properties:{};

          return String(properties['Bundle ID']||'')===String(state.submittedBundleId);
        });

        if(stillExists){
          throw new Error('The matching bundle lines were not removed from the cart.');
        }

        state.submittedBundleId='';
        state.submittedInCart=false;
        state.review=false;
        state.step=0;
        cartEditing=false;
        resetFilter();
        saveState();
        replaceBuilderHistory(false);
        render();
        scrollToBuilder();
        showToast('Bundle removed from the cart. Make your changes, then add it again.');
      }catch(error){
        cartEditing=false;
        render();
        console.error('Bundle edit could not start',error);
        showToast('We could not prepare this bundle for editing. It is still safely in your cart.');
      }
    }

    function loading(on){
      if(!nodes.loading)return;

      nodes.loading.classList.toggle('is-open',on);
      nodes.loading.setAttribute('aria-hidden',on?'false':'true');

      if(nodes.loadingLabel){
        nodes.loadingLabel.textContent=copy.preparing||'Adding Your Bundle...';
      }

      if(!on){
        if(nodes.loadingVisual){
          nodes.loadingVisual.innerHTML='';
        }
        return;
      }

      if(nodes.loadingVisual){
        nodes.loadingVisual.innerHTML=settings.preparingImage
          ? '<img src="'+escapeAttr(settings.preparingImage)+'" alt="">'
          : '<div class="bbb__box-loader"></div>';
      }
    }

    function resetBuilder(){
      clearSavedState();

      state.step=0;
      state.review=false;
      state.filter='All';
      state.sort='featured';
      state.lines=[];
      state.submittedBundleId='';
      state.submittedInCart=false;
      cartSubmitting=false;
      cartEditing=false;
      replaceBuilderHistory(false);
      render();
      scrollToBuilder();
    }

    function loadSavedState(){
      try{
        var raw=window.localStorage&&window.localStorage.getItem(storageKey);

        if(!raw)return;

        var saved=JSON.parse(raw);

        if(!saved||!saved.savedAt||Date.now()-saved.savedAt>storageMaxAge){
          clearSavedState();
          return;
        }

        var savedState=saved.state||{};

        state.step=Math.max(0,Math.min(1,+savedState.step||0));
        state.review=!!savedState.review;
        state.filter=savedState.filter?String(savedState.filter):'All';
        state.lines=Array.isArray(savedState.lines)
          ? savedState.lines.map(cleanSavedLine).filter(Boolean)
          : [];
        state.submittedBundleId=savedState.submittedBundleId
          ? String(savedState.submittedBundleId)
          : '';
        state.submittedInCart=!!savedState.submittedInCart&&!!state.submittedBundleId;

        if(state.submittedInCart){
          state.step=1;
          state.review=true;
        }

        if(!state.lines.length){
          state.step=0;
          state.review=false;
        }
      }catch(error){
        console.warn('Bundle builder saved state could not be loaded',error);
        clearSavedState();
      }
    }

    function cleanSavedLine(line){
      if(!line||!line.variantId)return null;

      return {
        key:String(line.key||'product:'+line.variantId),
        group:'product',
        productId:+line.productId||0,
        variantId:+line.variantId,
        title:String(line.title||''),
        variantTitle:String(line.variantTitle||''),
        price:+line.price||0,
        image:String(line.image||''),
        qty:Math.max(1,+line.qty||1)
      };
    }

    function saveState(){
      try{
        if(!window.localStorage)return;

        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            savedAt:Date.now(),
            state:{
              step:state.step,
              review:state.review,
              filter:state.filter,
              lines:state.lines,
              submittedBundleId:state.submittedBundleId,
              submittedInCart:state.submittedInCart
            }
          })
        );
      }catch(error){}
    }

    function clearSavedState(){
      try{
        if(window.localStorage){
          window.localStorage.removeItem(storageKey);
        }
      }catch(error){}
    }

    function resetFilter(){
      state.filter='All';
      state.sort='featured';
    }

    function prepareProducts(products){
      var output=products.filter(function(product){
        if(
          settings.hideSoldOut&&
          settings.trackInventory&&
          !product.variants.some(isAvailable)
        ){
          return false;
        }

        return state.filter==='All'||productMatchesType(product,state.filter);
      });

      if(state.sort==='az'){
        output.sort(function(a,b){return a.title.localeCompare(b.title);});
      }else if(state.sort==='za'){
        output.sort(function(a,b){return b.title.localeCompare(a.title);});
      }else if(state.sort==='price-low'){
        output.sort(function(a,b){return a.price-b.price;});
      }else if(state.sort==='price-high'){
        output.sort(function(a,b){return b.price-a.price;});
      }

      return output;
    }

    function productTypesFor(product){
      var types=[];
      var primary=productTypeFor(product);

      if(primary&&primary!=='All'){
        types.push(primary);
      }

      var tags=(product.tags||[]).map(cleanBuilderText);
      var text=[
        product.title||'',
        product.handle||'',
        product.type||'',
        product.category||'',
        (product.tags||[]).join(' ')
      ].join(' ').toLowerCase();

      var matching=
        tags.indexOf('matching')>-1||
        tags.indexOf('matching set')>-1||
        tags.indexOf('matching dog owner')>-1||
        tags.indexOf('matching dog and owner')>-1||
        (text.indexOf('matching')>-1&&(
          text.indexOf('owner')>-1||
          text.indexOf('human')>-1||
          text.indexOf('set')>-1
        ));

      if(matching&&types.indexOf('Matching Dog & Owner Sets')===-1){
        types.push('Matching Dog & Owner Sets');
      }

      if(!types.length){
        types.push('All');
      }

      return types;
    }

    function productTypeFor(product){
      var tags=(product.tags||[]).map(cleanBuilderText);

      function hasAny(values){
        return values.some(function(value){
          return tags.indexOf(cleanBuilderText(value))>-1;
        });
      }

      if(hasAny(['dog towel','dog towels'])){
        return 'Dog Towels';
      }

      if(hasAny(['dog drying robe','dog drying robes','drying robe','dog robe'])){
        return 'Dog Drying Robes';
      }

      if(hasAny(['dog hoodie','dog hoodies','dog jumper','dog jumpers','dog hoodie jumper','dog hoodies and jumpers'])){
        return 'Dog Hoodies & Jumpers';
      }

      if(hasAny(['dog treats','dog treat','treats'])){
        return 'Dog Treats';
      }

      if(hasAny(['adult hooded towel','adult hooded towels','adult towel','adult towels'])){
        return 'Adult Hooded Towels';
      }

      if(hasAny(['kids hooded towel','kids hooded towels','kid hooded towel','baby hooded towel','baby hooded towels','toddler hooded towel','toddler hooded towels'])){
        return 'Kids & Toddler Hooded Towels';
      }

      if(hasAny(['matching','matching set','matching dog owner','matching dog and owner'])){
        return 'Matching Dog & Owner Sets';
      }

      var text=[
        product.title||'',
        product.handle||'',
        product.type||'',
        product.category||'',
        (product.tags||[]).join(' ')
      ].join(' ').toLowerCase();

      if(text.indexOf('treat')>-1||text.indexOf('sardine')>-1||text.indexOf('mackerel')>-1||text.indexOf('fish skin')>-1||text.indexOf('training')>-1){
        return 'Dog Treats';
      }

      if(text.indexOf('hoodie')>-1||text.indexOf('jumper')>-1){
        return 'Dog Hoodies & Jumpers';
      }

      if(text.indexOf('adult')>-1||text.indexOf('changing robe')>-1||text.indexOf('beach poncho')>-1||text.indexOf('adult hooded')>-1){
        return 'Adult Hooded Towels';
      }

      if(text.indexOf('kids')>-1||text.indexOf('kid ')>-1||text.indexOf('toddler')>-1||text.indexOf('baby')>-1||text.indexOf('child')>-1){
        return 'Kids & Toddler Hooded Towels';
      }

      if(text.indexOf('drying robe')>-1||text.indexOf('dog robe')>-1||text.indexOf('dog drying coat')>-1||text.indexOf('drying coat')>-1||text.indexOf('dachshund')>-1||text.indexOf('dog coat')>-1){
        return 'Dog Drying Robes';
      }

      if(text.indexOf('dog towel')>-1||text.indexOf('chamois')>-1||text.indexOf('shammy')>-1||text.indexOf('noodle towel')>-1||text.indexOf('microfibre towel')>-1||text.indexOf('microfiber towel')>-1){
        return 'Dog Towels';
      }

      if(text.indexOf('matching')>-1&&(text.indexOf('owner')>-1||text.indexOf('human')>-1||text.indexOf('set')>-1)){
        return 'Matching Dog & Owner Sets';
      }

      return 'All';
    }

    function productMatchesType(product,type){
      if(!type||type==='All')return true;
      return productTypesFor(product).indexOf(type)>-1;
    }

    function cleanBuilderText(value){
      return String(value||'')
        .toLowerCase()
        .trim()
        .replace(/^builder:/,'')
        .replace(/&amp;/g,'and')
        .replace(/&/g,'and')
        .replace(/[_-]+/g,' ')
        .replace(/\s+/g,' ');
    }

    function findProduct(id){
      id=+id;

      return catalog.products.find(function(product){
        return product.id===id;
      })||null;
    }

    function cartLines(){
      return state.lines.slice();
    }

    async function refreshExistingBuilderValue(){
  try{
    var response=await fetch('/cart.js',{
      method:'GET',
      headers:{
        'Accept':'application/json'
      },
      cache:'no-store'
    });

    if(!response.ok){
      throw new Error(await response.text());
    }

    var cart=await response.json();

    /*
      When reviewing a bundle that is already in the cart,
      exclude that same bundle so it is not counted twice.
      After Create New Bundle clears the submitted ID, the
      previous bundle will count towards the new one.
    */
    var excludedBuilderId=
      state.submittedInCart&&
      state.submittedBundleId
        ? String(state.submittedBundleId)
        : '';

    existingBuilderEligible=
      (cart.items||[]).reduce(function(total,item){
        var props=
          item&&item.properties
            ? item.properties
            : {};

        var giftBoxId=String(
          props['Gift Box ID']||''
        );

        var bundleId=String(
          props['Bundle ID']||''
        );

        var builderId=
          giftBoxId||
          bundleId;

        var isBuilderItem=
          !!builderId||
          String(
            props['Gift Box Builder']||''
          ).toLowerCase()==='yes'||
          String(
            props['Bundle Builder']||''
          ).toLowerCase()==='yes';

        if(!isBuilderItem){
          return total;
        }

        if(
          excludedBuilderId&&
          builderId===excludedBuilderId
        ){
          return total;
        }

        /*
          Support newer cart lines that explicitly state
          whether they qualify for builder progress.
        */
        var explicitEligible=String(
          props['_Builder Eligible']||''
        ).toLowerCase();

        if(explicitEligible==='no'){
          return total;
        }

        if(explicitEligible!=='yes'){
          var group=String(
            props['_Builder Group']||''
          ).toLowerCase();

          if(
            group.indexOf('box')>-1||
            group.indexOf('card')>-1
          ){
            return total;
          }

          /*
            Compatibility with existing Gift Box Builder
            lines. The physical box stores Gift Box Items.
          */
          if(props['Gift Box Items']){
            return total;
          }

          /*
            Exclude greeting cards from older gift boxes.
            All Bundle Builder lines remain eligible.
          */
          if(!bundleId){
            var itemText=[
              item.product_title||'',
              item.product_type||'',
              item.variant_title||'',
              item.handle||''
            ]
              .join(' ')
              .toLowerCase();

            if(
              itemText.indexOf('greeting card')>-1||
              /(^|\s)card($|\s)/.test(itemText)
            ){
              return total;
            }
          }
        }

        /*
          Use original prices before an existing discount.
        */
        var amount=
          item.original_line_price!=null
            ? Number(item.original_line_price)||0
            : (
                item.line_price!=null
                  ? Number(item.line_price)||0
                  : (
                      Number(item.price)||0
                    )*
                    (
                      Number(item.quantity)||1
                    )
              );

        return total+amount;
      },0);

    console.log(
      'Bundle Builder existing eligible value:',
      existingBuilderEligible,
      'cents'
    );

    return existingBuilderEligible;

  }catch(error){
    console.warn(
      'Bundle Builder could not read the existing cart value:',
      error
    );

    return existingBuilderEligible;
  }
}

    function pricing(){
  /*
    subtotal and eligible belong only to the bundle currently
    being built.

    combinedEligible includes qualifying Gift Box Builder and
    Bundle Builder products already in the cart. It determines
    the active cart-wide discount tier.
  */
  var subtotal=state.lines.reduce(function(total,line){
    return total+line.price*line.qty;
  },0);

  var eligible=subtotal;

  var combinedEligible=
    existingBuilderEligible+
    eligible;

  var tier=tiers.slice().reverse().find(function(candidate){
    return combinedEligible>=candidate.threshold;
  });

  var percent=tier?+tier.percent:0;

  /*
    Display the saving on this bundle only. Existing cart
    products receive the same tier when the code is applied.
  */
  var discount=Math.round(
    eligible*
    percent/
    100
  );

  return {
    subtotal:subtotal,
    eligible:eligible,
    combinedEligible:combinedEligible,
    tier:tier,
    percent:percent,
    discount:discount,
    total:Math.max(
      0,
      subtotal-discount
    )
  };
}

    function discountMessage(eligible){
      var next=tiers.find(function(tier){
        return eligible<tier.threshold;
      });

      if(!next&&tiers.length){
        return tiers[tiers.length-1].percent+'% off unlocked.';
      }

      if(!next)return '';

      if(eligible<=0){
        return 'Add products to unlock '+next.percent+'% off.';
      }

      return 'Spend '+formatMoney(next.threshold-eligible)+' more to unlock '+next.percent+'% off.';
    }

    function discountProgress(eligible){
      if(!tiers.length)return 0;

      return Math.max(
        0,
        Math.min(
          100,
          Math.round(eligible/tiers[tiers.length-1].threshold*100)
        )
      );
    }

    function hasOptions(product){
      if(!product.variants||product.variants.length>1)return true;

      return product.options.some(function(option){
        return !isDefaultOption(option);
      });
    }

    function isDefaultOption(option){
      return !option||(
        String(option.name).toLowerCase()==='title'&&
        option.values.length===1&&
        String(option.values[0]).toLowerCase()==='default title'
      );
    }

    function firstVariant(product){
      return product&&product.variants
        ? (product.variants.find(isAvailable)||product.variants[0])
        : null;
    }

    function realOptions(product){
      return product&&Array.isArray(product.options)
        ? product.options.filter(function(option){
            return !isDefaultOption(option);
          })
        : [];
    }

    function selectedVariant(product){
      if(!product)return null;
      if(!hasOptions(product))return firstVariant(product);

      var options=realOptions(product);

      return product.variants.find(function(variant){
        return options.every(function(option,index){
          var actualIndex=product.options.indexOf(option);

          return (
            variant.options[actualIndex]===
            state.modal.options[index]
          );
        });
      })||null;
    }

    function optionValueAvailable(product,optionIndex,value){
      if(!settings.trackInventory){
        return true;
      }

      var options=realOptions(product);
      var option=options[optionIndex];

      if(!option){
        return false;
      }

      var actualIndex=product.options.indexOf(option);

      return product.variants.some(function(variant){
        if(!isAvailable(variant)){
          return false;
        }

        if(variant.options[actualIndex]!==value){
          return false;
        }

        return options
          .slice(0,optionIndex)
          .every(function(previousOption,index){
            var previousActualIndex=
              product.options.indexOf(previousOption);

            var selectedValue=
              state.modal.options[index];

            return (
              !selectedValue||
              variant.options[previousActualIndex]===selectedValue
            );
          });
      });
    }

    function syncModalOptions(product,changedIndex){
      if(!product)return;

      var exactVariant=selectedVariant(product);

      if(
        exactVariant&&
        (
          !settings.trackInventory||
          isAvailable(exactVariant)
        )
      ){
        return;
      }

      var options=realOptions(product);

      var replacement=product.variants.find(function(variant){
        if(
          settings.trackInventory&&
          !isAvailable(variant)
        ){
          return false;
        }

        return options
          .slice(0,changedIndex+1)
          .every(function(option,index){
            var actualIndex=product.options.indexOf(option);

            return (
              variant.options[actualIndex]===
              state.modal.options[index]
            );
          });
      });

      if(!replacement){
        replacement=firstVariant(product);
      }

      if(!replacement)return;

      state.modal.options=options.map(function(option){
        var actualIndex=product.options.indexOf(option);

        return replacement.options[actualIndex];
      });
    }

    function isAvailable(variant){
      return variant&&variant.available!==false;
    }

    function modalImages(product,variant){
      var images=[];

      if(variant&&variant.image){
        images.push(variant.image);
      }

      (product.images||[]).forEach(function(image){
        if(image&&images.indexOf(image)===-1){
          images.push(image);
        }
      });

      if(product.featuredImage&&images.indexOf(product.featuredImage)===-1){
        images.unshift(product.featuredImage);
      }

      return images;
    }

    function lineTitle(line){
      return line.variantTitle
        ? line.title+' - '+line.variantTitle
        : line.title;
    }

    function cleanVariantTitle(title){
      return !title||String(title).toLowerCase()==='default title'
        ? ''
        : title;
    }

    function imageMarkup(line,className){
      return line&&line.image
        ? '<img class="'+escapeAttr(className||'')+'" src="'+escapeAttr(line.image)+'" alt="'+escapeAttr(line.title)+'" loading="lazy">'
        : '<div class="bbb__fallback '+escapeAttr(className||'')+'">DD</div>';
    }

    function emptyProducts(){
      return '<div class="bbb__empty">'+escapeHtml(copy.noProducts||'No Products Available')+'</div>';
    }

    function formatMoney(cents){
      return money.format((+cents||0)/100);
    }

    function showToast(message){
      nodes.toast.textContent=message;
      nodes.toast.classList.add('is-visible');

      clearTimeout(showToast.timer);

      showToast.timer=setTimeout(function(){
        nodes.toast.classList.remove('is-visible');
      },2600);
    }

    function scrollToBuilder(){
      window.scrollTo({
        top:Math.max(
          0,
          root.getBoundingClientRect().top+
          window.scrollY-
          120
        ),
        behavior:'smooth'
      });
    }

    function truncate(value,length){
      value=String(value||'');
      return value.length>length?value.slice(0,length-1)+'…':value;
    }

    function normaliseProduct(product){
      if(!product||!product.id)return null;

      product.id=+product.id;
      product.handle=product.handle||'';
      product.url=product.url||'';
      product.type=product.type||'';
      product.category=product.category||'';
      product.description=product.description||'';
      product.descriptionHtml=product.descriptionHtml||'';
      product.builderDescriptionHtml=product.builderDescriptionHtml||'';
      product.builderSubtitle=product.builderSubtitle||'';
      product.tags=Array.isArray(product.tags)?product.tags.filter(Boolean):[];
      product.sizeGuide=product.sizeGuide&&product.sizeGuide.contentHtml
        ? product.sizeGuide
        : null;
      product.price=+product.price||0;
      product.images=Array.isArray(product.images)?product.images.filter(Boolean):[];
      product.options=Array.isArray(product.options)?product.options:[];
      product.variants=(Array.isArray(product.variants)?product.variants:[]).map(function(variant){
        return {
          id:+variant.id,
          title:variant.title||'',
          available:variant.available!==false,
          price:+variant.price||0,
          compareAt:variant.compareAt===null?null:+variant.compareAt||0,
          options:Array.isArray(variant.options)?variant.options:[],
          image:variant.image||null
        };
      });

      return product;
    }

    function escapeHtml(value){
      return String(value||'')
        .replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;')
        .replace(/'/g,'&#039;');
    }

    function escapeAttr(value){
      return escapeHtml(value).replace(/`/g,'&#096;');
    }
  });
})();